import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from "../hooks/useAuth"

const DashFooter = () => {
    const { username, status } = useAuth()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const onGoHomeClicked = () => {
        if (pathname === '/dash') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                navigate('/dash');
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }
    }

    return (
        <footer className="bg-dark text-light border-top border-secondary border-opacity-25 py-4 mt-auto">
            <div className="container">
                <div className="row gy-4 text-center text-md-start">

                    {/* Top: Home Button (always visible, full width on mobile) */}
                    <div className="col-12 col-md-4 d-flex justify-content-center justify-content-md-start">
                        <button
                            className="btn btn-outline-primary rounded-pill px-4 d-flex align-items-center gap-2 shadow-sm border-2"
                            onClick={onGoHomeClicked}
                            title="Về trang chủ"
                            style={{ minWidth: '140px' }}
                        >
                            <FontAwesomeIcon icon={faHouse} />
                            {/* Text now visible on ALL screens */}
                            <span className="ms-2">Trang chủ</span>
                        </button>
                    </div>

                    {/* Middle: User Info (perfectly centered on mobile) */}
                    <div className="col-12 col-md-4 order-md-2">
                        <div className="d-flex flex-wrap justify-content-center gap-3 small">
                            <p className="text-light opacity-75 small mb-1">
                                © 2025 <strong>Nhà đẹp</strong>. Tất cả quyền được bảo lưu.
                            </p>
                            <p className="text-light opacity-60 small mb-0">
                                Powered by{' '}
                                <a
                                    href="https://alildream.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-info fw-medium"
                                    style={{
                                        textDecoration: 'none',
                                        backgroundImage: 'linear-gradient(currentColor, currentColor)',
                                        backgroundPosition: '0% 100%',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: '0% 1.5px',
                                        transition: 'background-size 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundSize = '100% 1.5px'}
                                    onMouseLeave={(e) => e.target.style.backgroundSize = '0% 1.5px'}
                                >
                                    alildream
                                </a>{' '}
                                with <span className="text-danger">♥</span>
                            </p>
                        </div>
                    </div>

                    {/* Bottom: Copyright & Credit (centered on mobile) */}
                    <div className="col-12 col-md-4 order-md-3 text-center text-md-end small">
                        <span className="text-light opacity-80">
                            <i className="bi bi-person-circle me-1"></i>
                            <strong>{username || 'Guest'}</strong>
                        </span>
                        {' '}
                        <span className="text-info">
                            <i className="bi bi-shield-check me-1"></i>
                            {status || 'User'}
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default DashFooter